/*
  Instagram / Facebook / LINE のアプリ内ブラウザでは住所・カードの自動入力が効かず、
  チェックアウトを開いたまま閉じる人が多い（2026-10-13 ミルク販売で到達→購入 49%）。
  「購入手続きに進む」を押した瞬間にシートを出し、いつものブラウザ（Safari / Chrome）で
  購入画面を開けるようにする。急いでいる人はスクロールしないので、ボタン自体に仕掛ける。
  カートの中身と属性（配送希望日など）・備考はカートパーマリンクで引き継ぐ
  （attributes[...] と note が引き継がれることは 2026-10-13 に本番で確認済み）。
*/
(() => {
  if (window.__inappCheckout) return;
  window.__inappCheckout = true;

  const ua = navigator.userAgent || '';
  const app = /Instagram/i.test(ua) ? 'instagram'
    : /FBAN|FBAV|FB_IAB/.test(ua) ? 'facebook'
    : /\bLine\//i.test(ua) ? 'line'
    : null;
  if (!app) return;
  const os = /iPhone|iPad|iPod/.test(ua) ? 'ios' : /Android/.test(ua) ? 'android' : 'other';
  const appLabel = { instagram: 'Instagram', facebook: 'Facebook', line: 'LINE' }[app];

  // 外部ブラウザでは別の訪問として始まり、広告かストーリーかの UTM が消える（2026-10-14 の注文で確認）。
  // 着地時の UTM をこのタブに覚えておき、パーマリンクの URL と注文属性 _utm_* の両方で運ぶ。
  const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content'];
  const utmStoreKey = 'inapp_utm';
  (() => {
    const params = new URLSearchParams(location.search);
    const found = {};
    utmKeys.forEach(key => { if (params.get(key)) found[key] = params.get(key); });
    if (!Object.keys(found).length) return;
    try { sessionStorage.setItem(utmStoreKey, JSON.stringify(found)); } catch (e) { /* 保存できなくても購入は進める */ }
  })();
  function landingUtm() {
    try { return JSON.parse(sessionStorage.getItem(utmStoreKey) || '{}') || {}; } catch (e) { return {}; }
  }

  // 画面で選んだ希望日時は保存が非同期なので、カートより画面の値を優先する。
  const uiKeys = ['配送希望日', '配送希望時間帯'];
  function uiAttributes() {
    const out = {};
    const root = document.querySelector('fulfillment-preferences');
    if (!root) return out;
    uiKeys.forEach(key => {
      const el = [...root.querySelectorAll('[data-attr]')].find(e => e.dataset.attr === key);
      if (el) out[key] = el.value || '';
    });
    return out;
  }

  async function loadCart() {
    try {
      const res = await fetch(window.Shopify.routes.root + 'cart.js', { headers: { Accept: 'application/json' } });
      return res.ok ? await res.json() : null;
    } catch (e) {
      return null;
    }
  }

  function permalink(cart, target) {
    if (!cart || !cart.items.length) return null;
    // パーマリンクで運べないもの（定期便・明細のプロパティ）があるカートでは使わない。
    if (cart.items.some(i => i.selling_plan_allocation || Object.keys(i.properties || {}).length)) return null;
    const lines = cart.items.map(i => i.variant_id + ':' + i.quantity).join(',');
    const attrs = Object.assign({}, cart.attributes || {}, uiAttributes());
    attrs._inapp_handoff = app + '-' + os + '-' + target;
    const utm = landingUtm();
    Object.keys(utm).forEach(key => { attrs['_' + key] = utm[key]; });
    const query = Object.keys(attrs)
      .filter(k => attrs[k] !== '' && attrs[k] != null)
      .map(k => 'attributes%5B' + encodeURIComponent(k) + '%5D=' + encodeURIComponent(attrs[k]));
    if (cart.note) query.push('note=' + encodeURIComponent(cart.note));
    Object.keys(utm).forEach(key => query.push(key + '=' + encodeURIComponent(utm[key])));
    return 'https://' + location.host + window.Shopify.routes.root + 'cart/' + lines +
      (query.length ? '?' + query.join('&') : '');
  }

  function links(cart) {
    const https = target => permalink(cart, target);
    if (os === 'ios') {
      return [
        { label: 'Safariで購入手続きへ', href: https('safari').replace(/^https:\/\//, 'x-safari-https://') },
        { label: 'Chromeで購入手続きへ', href: https('chrome').replace(/^https:\/\//, 'googlechromes://') },
      ];
    }
    if (os === 'android') {
      const intent = (url, pkg) => 'intent://' + url.replace(/^https:\/\//, '') +
        '#Intent;scheme=https;' + (pkg ? 'package=' + pkg + ';' : '') + 'end';
      return [
        { label: 'Chromeで購入手続きへ', href: intent(https('chrome'), 'com.android.chrome') },
        {
          label: 'いつものブラウザで購入手続きへ',
          href: app === 'line' ? https('default') + '&openExternalBrowser=1' : intent(https('default')),
        },
      ];
    }
    return [];
  }

  let sheet = null;
  function buildSheet() {
    sheet = document.createElement('div');
    sheet.className = 'inapp-sheet';
    sheet.hidden = true;
    sheet.innerHTML =
      '<div class="inapp-sheet__backdrop" data-close></div>' +
      '<div class="inapp-sheet__panel" role="dialog" aria-modal="true" aria-labelledby="InappSheetTitle">' +
      '<button type="button" class="inapp-sheet__x" data-close aria-label="閉じる">×</button>' +
      '<div class="inapp-sheet__normal">' +
      '<p class="inapp-sheet__title" id="InappSheetTitle"><span data-app></span>のアプリ内では、住所やカードの自動入力が機能しない場合があります</p>' +
      '<p class="inapp-sheet__text">いつものブラウザなら自動入力でかんたんに進めます。カートの中身とお届け希望日はそのまま引き継がれます。</p>' +
      '<div class="inapp-sheet__links" data-links></div>' +
      '</div>' +
      '<div class="inapp-sheet__guide">' +
      '<span class="inapp-sheet__arrow" aria-hidden="true">↑</span>' +
      '<p class="inapp-sheet__title">画面右上の「…」をタップして、<br>「外部ブラウザで開く」を選んでください</p>' +
      '<p class="inapp-sheet__text">いつものブラウザで購入手続きの画面が開きます。カートの中身とお届け希望日はそのまま引き継がれます。</p>' +
      '</div>' +
      '<button type="button" class="inapp-sheet__stay" data-stay>このまま購入手続きへ</button>' +
      '<div class="inapp-sheet__copy"><button type="button" data-copy>リンクをコピー</button>' +
      '<span data-copy-status role="status" aria-live="polite"></span></div>' +
      '<input type="text" class="inapp-sheet__url" data-url readonly hidden aria-label="購入手続きのリンク">' +
      '</div>';
    document.body.appendChild(sheet);
    sheet.querySelector('[data-app]').textContent = appLabel;
    sheet.addEventListener('click', onSheetClick);
    document.addEventListener('keydown', e => { if (e.key === 'Escape' && !sheet.hidden) close(); });
  }

  let pendingButton = null;
  let stayed = false;
  let currentCart = null;
  let originalUrl = null;

  // アプリがブラウザを開けたかは分からないので、ページが隠れなかったら開けなかったとみなす。
  let left = false;
  document.addEventListener('visibilitychange', () => { if (document.hidden) left = true; });
  window.addEventListener('pagehide', () => { left = true; });
  window.addEventListener('blur', () => { left = true; });

  function tryExternal() {
    left = false;
    setTimeout(() => { if (!left && !document.hidden && !sheet.hidden) showMenuGuide(); }, 1500);
  }

  // 2026-10-13: Instagram（iPhone）は x-safari-https:// を開かない。
  // アプリ右上の「…」→「外部ブラウザで開く」は表示中の URL を開くので、
  // 表示中の URL をカートパーマリンクに差し替えてから、そのメニューへ案内する。
  function showMenuGuide() {
    if (originalUrl == null) originalUrl = location.href;
    try { history.replaceState(history.state, '', permalink(currentCart, 'menu')); } catch (e) { /* 失敗してもコピーで進める */ }
    sheet.classList.add('inapp-sheet--guide');
    document.documentElement.classList.add('inapp-sheet-open');
    sheet.hidden = false;
  }

  function restoreUrl() {
    if (originalUrl == null) return;
    try { history.replaceState(history.state, '', originalUrl); } catch (e) { /* 何もしない */ }
    originalUrl = null;
  }

  function open(cart, button) {
    if (!sheet) buildSheet();
    pendingButton = button;
    currentCart = cart;
    sheet.classList.remove('inapp-sheet--guide');
    const box = sheet.querySelector('[data-links]');
    box.innerHTML = '';
    const directSafariBlocked = app === 'instagram' && os === 'ios';
    links(cart).forEach((link, index) => {
      const a = document.createElement('a');
      a.className = 'button inapp-sheet__button' + (index ? ' button--secondary' : '');
      a.href = link.href;
      a.textContent = link.label;
      if (directSafariBlocked && /^x-safari-/.test(link.href)) {
        a.addEventListener('click', event => { event.preventDefault(); showMenuGuide(); });
      } else {
        a.addEventListener('click', tryExternal);
      }
      box.appendChild(a);
    });
    const input = sheet.querySelector('[data-url]');
    input.value = permalink(cart, 'copy');
    input.hidden = true;
    sheet.querySelector('[data-copy-status]').textContent = '';
    sheet.hidden = false;
    document.documentElement.classList.add('inapp-sheet-open');
    const first = box.querySelector('a');
    if (first) first.focus({ preventScroll: true });
  }

  function close() {
    sheet.hidden = true;
    sheet.classList.remove('inapp-sheet--guide');
    document.documentElement.classList.remove('inapp-sheet-open');
    restoreUrl();
  }

  async function onSheetClick(event) {
    if (event.target.closest('[data-close]')) {
      close();
      return;
    }
    if (event.target.closest('[data-stay]')) {
      stayed = true;
      close();
      if (pendingButton) pendingButton.click();
      return;
    }
    if (event.target.closest('[data-copy]')) {
      const input = sheet.querySelector('[data-url]');
      let ok = false;
      try {
        await navigator.clipboard.writeText(input.value);
        ok = true;
      } catch (e) {
        input.hidden = false;
        input.focus();
        input.select();
        try { ok = document.execCommand('copy'); } catch (e2) { ok = false; }
      }
      sheet.querySelector('[data-copy-status]').textContent = ok
        ? 'コピーしました。ブラウザのアドレス欄に貼り付けてください。'
        : '上のリンクを長押しでコピーしてください。';
    }
  }

  // 「購入手続きに進む」（ドロワー・カートページ）を押したときだけ割り込む。
  // 「このまま」を選んだ人には、そのページでは二度と出さない。
  document.addEventListener('click', async event => {
    if (stayed) return;
    const button = event.target.closest && event.target.closest('button[name="checkout"]');
    if (!button || button.disabled) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const cart = await loadCart();
    if (!permalink(cart, 'probe') || !links(cart).length) {
      // 引き継げないカートや、開き方が分からない端末では、いつもどおり進める。
      stayed = true;
      button.click();
      return;
    }
    open(cart, button);
  }, true);
})();
